<template>
  <div class="app-container">
    <div class="title-row"><span class="title">{{ titleName }}</span></div>
    <el-form :model="queryParams" ref="queryForm" :inline="true" size="small" v-show="showSearch" label-width="68px">
      <el-form-item label="所属系统" prop="metroCode">
        <el-select v-model="queryParams.metroCode" @change="changeMetro">
          <el-option v-for="item in metroOptions" :key="item.metroCode" :label="item.metroName" :value="item.metroCode"/>
        </el-select>
      </el-form-item>
      <el-form-item label="线路编码" prop="lineCode">
        <el-input v-model="queryParams.lineCode" placeholder="请输入线路编码" clearable @keyup.enter.native="handleQuery"/>
      </el-form-item>
      <el-form-item label="线路名称" prop="lineName">
        <el-input v-model="queryParams.lineName" placeholder="请输入线路名称" clearable @keyup.enter.native="handleQuery"/>
      </el-form-item>
      <el-form-item label="线路别名" prop="aliasName">
        <el-input v-model="queryParams.aliasName" placeholder="请输入线路别名" clearable  @keyup.enter.native="handleQuery"/>
      </el-form-item>
      <el-form-item label="线路状态" prop="lineStatus" >
        <el-select v-model="queryParams.lineStatus" placeholder="线路状态" @change="handleQuery" clearable >
          <el-option v-for="dict in dict.type.metro_status" :key="dict.value" :label="dict.label" :value="dict.value"/>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-search" size="mini" @click="handleQuery">搜索</el-button>
        <el-button icon="el-icon-refresh" size="mini" @click="resetQuery">重置</el-button>
      </el-form-item>
    </el-form>

    <el-row :gutter="10" class="mb8">
      <el-col :span="1.5">
        <el-button v-hasPermi="['metro:line:add']" type="primary" plain icon="el-icon-plus" size="mini" @click="handleAdd" >新增</el-button>
      </el-col>
      <right-toolbar :showSearch.sync="showSearch" @queryTable="getList" ></right-toolbar>
    </el-row>

    <el-table v-loading="loading" :data="lineList" style="width: 100%" border >
      <el-table-column type="index" label="序号" align="center" width="60"/>
      <el-table-column label="线路编码" align="center" prop="lineCode" min-width="90"/>
      <el-table-column label="线路名称" align="center" prop="lineName" min-width="90">
        <template slot-scope="scope">
          <a v-if="$auth.hasPermi('metro:station:list')" class="link-type" style="cursor:pointer" @click="handleViewData(scope.row)">{{ scope.row.lineName }}</a>
          <span v-else>{{ scope.row.lineName }}</span>
        </template>
      </el-table-column>
      <el-table-column label="线路别名" align="center" prop="aliasName" min-width="90"/>
      <el-table-column label="标识色" align="center" prop="lineColor" min-width="90">
        <template slot-scope="scope">
          <el-tag style="border: none" v-if="scope.row.lineColor" :color="scope.row.lineColor" effect="dark" :hit="false">{{scope.row.lineColor}}</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="线路状态" align="center" prop="lineStatus" min-width="90">
        <template slot-scope="scope">
          <el-switch
              v-if="$auth.hasPermiOr(['metro:line:add','metro:line:edit'])"
              v-model="scope.row.lineStatus"
              active-value="1"
              inactive-value="0"
              active-color="#13ce66"
              @change="handleStatusChange(scope.row)"
          ></el-switch>
          <dict-tag v-else :options="dict.type.metro_status" :value="scope.row.lineStatus"/>
        </template>
      </el-table-column>
      <el-table-column label="排序" align="center" prop="orderNum" min-width="60"/>
      <el-table-column label="线路长度(km)" align="center" prop="lineLength" width="120"/>
      <el-table-column label="站点总数" align="center" prop="stationCount" min-width="90"/>
      <el-table-column label="运营站点" align="center" prop="operateStationCount" min-width="90"/>
      <el-table-column label="备注" align="center" prop="remark" min-width="180"/>
      <el-table-column label="操作" align="center" class-name="small-padding fixed-width" width="200">
        <template slot-scope="scope">
          <el-button v-hasPermi="['metro:line:edit']" size="mini" type="text" icon="el-icon-edit" @click="handleUpdate(scope.row)" >修改</el-button>
          <el-button v-hasPermi="['metro:station:list']" size="mini" type="text" icon="el-icon-s-operation" @click="handleToStation(scope.row)" >站点</el-button>
          <el-button v-hasPermi="['metro:line:remove']" size="mini" type="text" icon="el-icon-delete" @click="handleDelete(scope.row)" >删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 添加或修改轨道交通线路对话框 -->
    <el-dialog :title="title" :visible.sync="open" width="650px" :close-on-click-modal="false"  append-to-body>
      <el-form ref="form" :model="form" :rules="rules" label-width="90px">
        <el-row :gutter="10">
          <el-col :span="24">
            <el-form-item label="所属系统" prop="metroCode">
              <el-select v-model="form.metroCode" :disabled="metroCodeDisabled">
                <el-option v-for="item in metroOptions" :key="item.metroCode" :label="item.metroName" :value="item.metroCode"/>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item label="线路编码" prop="lineCode">
              <el-input v-model="form.lineCode" placeholder="请输入线路编码" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="线路名称" prop="lineName">
              <el-input v-model="form.lineName" placeholder="请输入线路名称" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item label="线路状态" prop="lineStatus">
              <el-radio-group v-model="form.lineStatus">
                <el-radio
                  v-for="dict in dict.type.metro_status"
                  :key="dict.value"
                  :label="dict.value"
                >{{dict.label}}</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="排序" prop="orderNum">
              <el-input-number :min="1" v-model="form.orderNum" placeholder="请输入排序" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item label="线路别名" prop="aliasName">
              <el-input v-model="form.aliasName" placeholder="请输入线路别名" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="标识色" prop="lineColor">
              <el-color-picker v-model="form.lineColor"></el-color-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item label="线路长度" prop="lineLength">
              <el-input v-model="form.lineLength" placeholder="请输入线路长度" >
                <template slot="append">km</template>
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="24">
            <el-form-item label="备注" prop="remark">
              <el-input v-model="form.remark" type="textarea" placeholder="请输入内容" />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitForm">确 定</el-button>
        <el-button @click="cancel">取 消</el-button>
      </div>
    </el-dialog>
    <line-detail :visible.sync="drawerVisible" :row="drawerRow" />
  </div>
</template>

<script>
import { listLine, getLine, delLine, addLine, updateLine,updateStatus } from "@/api/metro/line"
import { getMetro,metroSelect } from "@/api/metro/sys"
import LineDetail from "./line-detail"
export default {
  components: { LineDetail },
  name: "MetroLine",
  dicts: ['metro_status'],
  data() {
    return {
      titleName: '',
      // 遮罩层
      loading: true,
      showSearch:true,
      // 总条数
      total: 0,
      // 轨道交通线路表格数据
      lineList: [],
      // 弹出层标题
      title: "",
      // 是否显示弹出层
      open: false,
      // 查询参数
      queryParams: {
        lineCode: null,
        lineName: null,
        aliasName: null,
        metroCode: null,
        lineColor: null,
        lineStatus: null,
        orderNum: null,
      },
      pathParams: {
        metroCode: null
      },
      metroOptions: [],
      metroCodeDisabled: false,
      // 表单参数
      form: {},
      // 表单校验
      rules: {
        lineCode: [
          { required: true, message: "线路编码不能为空", trigger: "blur" }
        ],
        lineName: [
          { required: true, message: "线路名称不能为空", trigger: "blur" }
        ],
        metroCode: [
          { required: true, message: "所属系统不能为空", trigger: "blur" }
        ],
        lineStatus: [
          { required: true, message: "线路状态不能为空", trigger: "blur" }
        ],
        orderNum: [
          { required: true, message: "排序不能为空", trigger: "blur" }
        ],
      },
      // 站点数据抽屉状态
      drawerVisible: false,
      // 站点数据信息
      drawerRow: {}
    }
  },
  created() {
    const metroId = this.$route.query.metroId;
    getMetro(metroId).then(res=>{
      if(res.code === 20000){
        this.pathParams.metroCode = res.data.metroCode
        this.titleName = res.data.metroName + "线路"
        this.getMetroOptions(this.pathParams.metroCode)
      }
    })

  },
  methods: {
    getMetroOptions(metroCode){
      metroSelect().then(response => {
        this.metroOptions = response.data
        this.queryParams.metroCode = metroCode
        this.getList()
      })
    },
    changeMetro(item){
      const metro = this.metroOptions.find(obj=>obj.metroCode===item)
      this.titleName = metro.metroName + "线路"
      this.getList()
    },
    /** 查询轨道交通线路列表 */
    getList() {
      this.loading = true
      listLine(this.queryParams).then(response => {
        this.lineList = response.data
        this.total = response.data.length
        this.loading = false
      })
    },
    // 线路状态修改
    handleStatusChange(row) {
      let text = row.lineStatus === "0" ? "未运营" : "运营中";
      this.$modal.confirm('确认要将【'+row.lineName+'】设置为"' + text + '"吗？').then(function() {
        return updateStatus(row.lineId, row.lineStatus);
      }).then(() => {
        this.$modal.msgSuccess("设置"+text + "成功");
      }).catch(function() {
        row.lineStatus = row.lineStatus === "0" ? "1" : "0";
      });
    },
    // 取消按钮
    cancel() {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset() {
      this.form = {
        lineId: null,
        lineCode: null,
        lineName: null,
        aliasName: null,
        metroCode: this.pathParams.metroCode,
        lineColor: null,
        lineStatus: "0",
        orderNum: null,
        createBy: null,
        createTime: null,
        updateBy: null,
        updateTime: null,
        remark: null
      }
      this.resetForm("form")
    },
    /** 搜索按钮操作 */
    handleQuery() {
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.resetForm("queryForm")
      this.queryParams.metroCode = this.pathParams.metroCode
      this.handleQuery()
    },
    handleToStation(row){
      this.$tab.openPage('轨道站点','/metro/metro-station',{ lineId: row.lineId});
    },
    /** 新增按钮操作 */
    handleAdd() {
      this.reset()
      this.metroCodeDisabled = false
      this.open = true
      this.title = "添加轨道交通线路"
    },
    /** 修改按钮操作 */
    handleUpdate(row) {
      this.reset()
      this.metroCodeDisabled = true
      const lineId = row.lineId
      getLine(lineId).then(response => {
        this.form = response.data
        this.open = true
        this.title = "修改轨道交通线路"
      })
    },
    /** 提交按钮 */
    submitForm() {
      this.$refs["form"].validate(valid => {
        if (valid) {
          if (this.form.lineId != null) {
            updateLine(this.form).then(response => {
              this.$modal.msgSuccess("修改成功")
              this.open = false
              this.getList()
            })
          } else {
            addLine(this.form).then(response => {
              this.$modal.msgSuccess("新增成功")
              this.open = false
              this.getList()
            })
          }
        }
      })
    },
    /** 删除按钮操作 */
    handleDelete(row) {
      this.$modal.confirm('是否确认删除轨道交通线路名称为"' + row.lineName + '"的数据项？').then(function() {
        return delLine(row.lineId)
      }).then(() => {
        this.getList()
        this.$modal.msgSuccess("删除成功")
      }).catch(() => {})
    },
    /** 站点数据抽屉显示信息 */
    handleViewData(row){
      this.drawerRow = row
      this.drawerVisible = true
    }
  }
}
</script>
